export enum BUSINESS_NATURE {
  ABO = 1,
  MEMBER_PLUS = 2,
  MEMBER = 3,
  CUSTOMER = 4,
  MARKET_ADVISOR = 5,
  AMWAY_OF = 6,
  EMPLOYEE = 7,
  BSC = 8,
  GPKH = 9,
  GUEST_CUSTOMER = 17,
}

export const CUSTOMER_BUSINESS_NATURES = new Set([
  BUSINESS_NATURE.MEMBER,
  BUSINESS_NATURE.CUSTOMER,
  BUSINESS_NATURE.GUEST_CUSTOMER,
]); // Member, Customer, GuestCustomer
